
export const CHECK_CART_STATUS_START = "CHECK_CART_STATUS_START";
export const CHECK_CART_STATUS_SUCCESS = "CHECK_CART_STATUS_SUCCESS";
export const CHECK_CART_STATUS_ERROR = "CHECK_CART_STATUS_ERROR";

export const BOOKING_SUMMARY_FOR_CART_START = "BOOKING_SUMMARY_FOR_CART_START";
export const BOOKING_SUMMARY_FOR_CART_SUCCESS = "BOOKING_SUMMARY_FOR_CART_SUCCESS";
export const BOOKING_SUMMARY_FOR_CART_ERROR = "BOOKING_SUMMARY_FOR_CART_ERROR";

export const ADD_TO_CART_START = "ADD_TO_CART_START";
export const ADD_TO_CART_SUCCESS = "ADD_TO_CART_SUCCESS";
export const ADD_TO_CART_ERROR = "ADD_TO_CART_ERROR";

export const SAVE_RIDER_START = "SAVE_RIDER_START";
export const SAVE_RIDER_SUCCESS = "SAVE_RIDER_SUCCESS";
export const SAVE_RIDER_ERROR = "SAVE_RIDER_ERROR";

export const TOUR_ORDER_SUCCESS_DETAILS_START = "TOUR_ORDER_SUCCESS_DETAILS_START";
export const TOUR_ORDER_SUCCESS_DETAILS_SUCCESS = "TOUR_ORDER_SUCCESS_DETAILS_SUCCESS";
export const TOUR_ORDER_SUCCESS_DETAILS_ERROR = "TOUR_ORDER_SUCCESS_DETAILS_ERROR";

export const GET_ACCOMODATION_DETAILS_START = "GET_ACCOMODATION_DETAILS_START";
export const GET_ACCOMODATION_DETAILS_SUCCESS = "GET_ACCOMODATION_DETAILS_SUCCESS";
export const GET_ACCOMODATION_DETAILS_ERROR = "GET_ACCOMODATION_DETAILS_ERROR";